import React from "react";

import "./Header.css";

export default function Header() {
  return (
    <div className="card-header">
      <h2>WeatherApp</h2>
    </div>
  );
}
